import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@price-management-console/auth';
import { filter, of, switchMap, take } from 'rxjs';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return toObservable(authService.isLoading).pipe(
    filter((isLoading) => !isLoading), // Wait until loading is false
    take(1), // Only need the first emission where loading is false
    switchMap(() => {
      if (authService.initializationError()) {
        return of(router.createUrlTree(['/error', '403'])); // Route to unauthorized if initialization failed
      }
      if (authService.isAuthenticated()) {
        return of(true); // User is authenticated, allow access
      }

      // Fire and forget. OIDC login trigger full-page redirect
      authService.oidcLogin();

      // Deny access for this request
      return of(false);
    })
  );
};
